/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Contract_Seats_HintInputs */



/**
* | output |
* | --- |
* | "The agreed number is billed every period, whether or not every seat is taken." |
*
* @param {Partner_Org_Contract_Seats_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_seats_hint = /** @type {((inputs?: Partner_Org_Contract_Seats_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Seats_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die vereinbarte Anzahl wird in jeder Periode abgerechnet, unabhängig davon, wie viele Plätze belegt sind.")
	return /** @type {LocalizedString} */ ("The agreed number is billed every period, whether or not every seat is taken.")
});